import { render } from "./PlatformPage.vue?vue&type=template&id=62f40101&scoped=true"
import script from "./PlatformPage.vue?vue&type=script&lang=js"
export * from "./PlatformPage.vue?vue&type=script&lang=js"

import "./PlatformPage.vue?vue&type=style&index=0&id=62f40101&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f40101"]])

export default __exports__